import Vue from 'vue'
import iview from 'view-design'
import SliderVerificationCode from 'slider-verification-code'
import "ztree"
import 'ztree/css/zTreeStyle/zTreeStyle.css';
Vue.use(iview)
Vue.use(SliderVerificationCode)